import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { DollarAmount } from 'common/display/Money';

const CardDataItem = ({
  dataLabel,
  isHTML,
  label,
  required,
  value,
  amountField,
}) => (
  <div className="card-data__item">
    <div className="card-data__label-container col-sm-3">
      <span className={cx(
        'card-data__label font-heavy-font text-text-blue',
        required && 'ui-form-field__label--required',
      )}
      >
        {label}:
      </span>
    </div>
    <div className="col-sm-9">
      {amountField &&
        (
          <DollarAmount
            value={value}
            convertCents
            className={required ? 'text-red' : 'text-text-blue'}
            dataLabel={dataLabel}
          />
        )}
      {!amountField && isHTML && (
        // eslint-disable-next-line react/no-danger
        <span className="text-text-blue" data-test-element={dataLabel} dangerouslySetInnerHTML={{ __html: value }} />
      )}
      {!amountField && !isHTML && (
        <span className={required ? 'text-red' : 'text-text-blue'} data-test-element={dataLabel}>{value}</span>
      )}
    </div>
  </div>
);

CardDataItem.propTypes = {
  dataLabel: PropTypes.string,
  isHTML: PropTypes.bool,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  value: PropTypes.node.isRequired,
  amountField: PropTypes.bool,
};

CardDataItem.defaultProps = {
  dataLabel: '',
  isHTML: false,
  required: false,
  amountField: false,
};

export default CardDataItem;
